<template>

<h1>7</h1>

</template>

<script>
export default {
  name: "Button7",


  data() {
    return    {


    }
  },

  methods : {

  }
}
</script>

<style scoped>



</style>
